import React, { useRef } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import withObserver from "../../moduleable/modules/hoc/withObserver.js"
import { FormattedMessage } from 'react-intl'
import { Products, EmptyProducts, SimpleProducts, SimpleEmptyProducts } from "../../listing/components/list/index.jsx";
import { useState } from "react";
import withFirst from "../hoc/withFirst";
import { fetchProductYouLikes, fetchProductOftenWith } from "../../../../api";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Affix from "../../../components/affix";

const OftenWithItem = props =>{
    const { products, loadHandle, loading, finished, skip } = props;

    return <div style={{ paddingBottom: '15px' }}>
        {
            products?.length > 0 && <SimpleProducts
                products={products}
                sensors={{
                    resourcepage_title: 'product',
                    resource_position: '1',
                    resource_type: '4',
                    resource_content: 'You can match with'
                }}
                column="Often Bought With" 
            />
        }

        {
            skip <= 0 && products?.length <=0 && <SimpleEmptyProducts count={21} />
        }

        {
            finished && <div className={classes.Finished}>
                <FormattedMessage id="finished" defaultMessage="Finished" />
            </div>
        }

        {
            skip > 0 && loading && !finished && <div className={classes.Loading}>
                <FormattedMessage id="loading" defaultMessage="Loading" />
            </div>
        }

        {
            !loading && !finished && <div onClick={loadHandle} className={classes.ViewMore}>
                <span><FormattedMessage id="view_more" defaultMessage="View More" />{' >'}</span>
            </div>
        }

    </div>
}

const OftenWith = props => {
    const { productId, selectedName } = props;
    const LIMIT = 21;
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([]);
    const [skip, setSkip] = useState(0);
    const [finished, setFinished] = useState(false);
    const initedRef = useRef(false);

    useEffect(() =>{
        if(selectedName === 'oftenwith' && !initedRef.current){
            loadHandle();
            initedRef.current = true;
        }
    },[selectedName]);
    
    const loadHandle = async () => {
        let limit = skip <= 0 ? 60 : LIMIT;
        try {
            setLoading(true)
            const products = await fetchProductOftenWith({ skip: skip, limit: limit, productId: productId })
                .then(response => {
                    const productItems = response?.result?.map(p => ({
                        ...p,
                        geekoRequsestId: response.requestId,
                        geekoExperimentId: response.experimentId,
                        layerName: response.layerName,
                        trackingRecords: response.trackingRecords
                    }))
                    return productItems || [];
                })
                .catch(data => {
                    console.error(data)
                    return []
                }
            )

            setProducts(preValue => [...preValue, ...products]);
            setSkip((preValue) => preValue += limit);
            setLoading(false)
            setFinished(!!!products || products?.length < 20);
        } catch (response) {
            alert(response);
        }
    }

    return <React.Fragment>
        <OftenWithItem skip={skip} loading={loading} products={products} loadHandle={loadHandle} finished={finished} />
    </React.Fragment>

}

const YouLikesItem = withFirst(props => {
    const { products, loadHandle, loading, finished, innerRef, selectedName, skip } = props;

    return (
        <>
            <div ref={innerRef}></div>
            {
                selectedName === 'youlikes' && <div>
                    {
                        products?.length > 0 && <SimpleProducts
                            products={products}
                            sensors={{
                                resourcepage_title: 'product',
                                resource_position: '1',
                                resource_type: '4',
                                resource_content: 'You may also like'
                            }}
                            column="You May Also Like"
                        />
                    }

                    {
                        skip <= 0 && products?.length <=0 && <SimpleEmptyProducts count={21} />
                    }

                    {
                        finished && <div className={classes.Finished}>
                            <FormattedMessage id="finished" defaultMessage="Finished" />
                        </div>
                    }

                    {
                        skip > 0 && loading && !finished && <div className={classes.Loading}>
                            <FormattedMessage id="loading" defaultMessage="Loading" />
                        </div>
                    }

                    {
                        !loading && !finished && <div onClick={loadHandle} className={classes.ViewMore}>
                            <span><FormattedMessage id="view_more" defaultMessage="View More" />{' >'}</span>
                        </div>
                    }
                </div>
            }
        </>
    )
});

const YouLikes = props => {
    const { selectedName } = props;
    let inited = false
    const LIMIT = 21;
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([]);
    const [skip, setSkip] = useState(0);
    const [finished, setFinished] = useState(false);

    const loadHandle = async () => {
        let limit = skip <= 0 ? 48 : LIMIT;
        try {
            setLoading(true)
            const products = await fetchProductYouLikes({ skip: skip, limit: limit, productId: props.productId })
                .then(response => {
                    const productItems = response.result?.map(p => ({
                        ...p,
                        geekoRequsestId: response.requestId,
                        geekoExperimentId: response.experimentId,
                        layerName: response.layerName,
                        trackingRecords: response.trackingRecords
                    }))
                    return productItems || [];
                })
                .catch(data => {
                    console.error(data)
                    return []
                }
                )

            setProducts(preValue => [...preValue, ...products]);
            setSkip((preValue) => preValue += limit);
            setLoading(false)
            setFinished(!!!products || products?.length < 1);
        } catch (response) {
            alert(response);
        }
    }

    const initData = async () => {
        if (!inited) {
            inited = true
            if (props?.productId) {
                loadHandle();
            }
        }
    }

    return (
        <YouLikesItem initLoad={initData} skip={skip} loading={loading} products={products} loadHandle={loadHandle} finished={finished} selectedName={selectedName} />
    )
}


const ProductRecommend = (props) => {
    useStyles(classes);
    const { innerRef, productHooks, productId } = props;
    const { selectedName, setSelectedName, isATest } = productHooks;
    // const redDotShow = useRef(false);
    // const dispatch = useDispatch();
    // const [fixed, setFixed] = useState(false);
    // const scrollTopRef = useRef({
    //     leftOffsetTop:0,
    //     rightOffsetTop:0
    // });
    
    // const getCurrentOffsetTop = () =>{
    //     let domCurrent = document.getElementById("youLikesNav");
    //     let currentOffsetTop = domCurrent.offsetTop + domCurrent.offsetParent.offsetTop - 90;
    //     return currentOffsetTop;
    // }

    // const getCurrentScrollTop = () =>{
    //     return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    // }

    // useEffect(() =>{
    //     // console.log('fixed', fixed)
    //     // 第一次获取到often boght with的初试对于顶部距离
    //     if(fixed){
    //         let currentOffsetTop = getCurrentScrollTop();
    //         scrollTopRef.current.leftOffsetTop = currentOffsetTop;
    //         scrollTopRef.current.rightOffsetTop = currentOffsetTop;
    //     }
    // },[fixed]);

    // const oftenWithEVent = async () => {
    //     setSelectedName("oftenwith");
    //     redDotShow.current = true;

    //     if(!fixed || selectedName === 'oftenwith') return;
    //     scrollTopRef.current.leftOffsetTop = getCurrentScrollTop();

    //     window.scrollTo(0, scrollTopRef.current.rightOffsetTop);
    // }

    const youLikesEvent = () =>{
        // if(!isATest) return;
        // setSelectedName("youlikes");

        // if(!fixed || selectedName === 'youlikes') return;
        // scrollTopRef.current.rightOffsetTop = getCurrentScrollTop();

        // window.scrollTo(0, scrollTopRef.current.leftOffsetTop);
    }

    return (
        <div className={`${classes.GolbalBorderTop} ${classes.YouMayAlsoLikes}`}>
            <div ref={innerRef} id="youLikesNav" />

            {/* callBack={f => {setFixed(f)}} */}
            <Affix offsetTop={88} >
                <div className={classes.Hd}>
                    <span onClick={youLikesEvent} className={`${selectedName === 'youlikes' ? classes.Active : ''} ${classes.BTest}`}>
                        <FormattedMessage id="you_may_also_likes" defaultMessage="You May Also Like" />
                    </span>

                    {/* {
                        isATest && <span onClick={oftenWithEVent} className={`${selectedName === 'oftenwith' ? classes.Active : ''}`}>
                            <FormattedMessage id="you_can_match_with" defaultMessage="You Can Match With" />
                            {
                                selectedName !== 'oftenwith' && !redDotShow.current && <span className={classes.RedDot}></span>
                            }
                        </span>
                    } */}
                </div>
            </Affix>

            <div id="youLikesNav2" />
            
                        
            <div style={{display:`${selectedName === 'youlikes'?"block":"none"}`}} className={classes.ContentMargin}>
                <YouLikes productId={productId} selectedName={selectedName} />
            </div>
            
            {/* {
                isATest && <div style={{display:`${selectedName !== 'youlikes'?"block":"none"}`}} className={classes.ContentMargin}>
                    <OftenWith {...props} productId={productId} selectedName={selectedName} />
                </div>
            } */}
        </div>
    )
}


export default withObserver(ProductRecommend);